import moment from 'moment'
import Vue from 'vue'

Vue.filter('tva', function(value: number, isInt:boolean = true, local:string='fr-FR') {
  if (value || value === 0) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'percent',
        minimumFractionDigits:0,
        maximumFractionDigits:2
      }).format(value/(isInt?10000.0:100.0))     
  }
  return ""
})